import React, { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useLocalStorage from "../../common/hooks/useLocalStorage";
import { LOCAL_STORAGE_KEYS } from "../../common/consts";
import { validateOutreachAuthCode } from "../../services/firebase";
import Loading, { LoadingVariant } from "../../components/Display/Loading";

const OutreachRedirect: FC = () => {
  const [, setOutreachAuthCode] = useLocalStorage(
    LOCAL_STORAGE_KEYS.outreachAuthCode,
    ""
  );
  const [validating, setValidating] = useState(false);
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");

  useEffect(() => {
    if (!code) {
      const error = new URLSearchParams(search).get("error");
      if (error) {
        console.error("Outreach OAuth error:", error);
        localStorage.setItem("oauthCodeFailed", "true");
        localStorage.setItem("oauthCodeFailedAt", Date.now().toString());
        window.location.href = "/app/dashboard";
      }
      return;
    }

    let cancelled = false;

    const run = async () => {
      setValidating(true);
      localStorage.setItem("oauthCodeProcessing", "true");
      localStorage.setItem("oauthCodeProcessingTime", Date.now().toString());

      try {
        const { status, result } = await validateOutreachAuthCode(code);
        if (cancelled) return;

        if (status === 200 && result?.isOutreachAuthorized && result) {
          localStorage.setItem(LOCAL_STORAGE_KEYS.pendingOrganization, JSON.stringify(result));
          localStorage.removeItem(LOCAL_STORAGE_KEYS.outreachAuthCode);
          setOutreachAuthCode("");
          localStorage.removeItem("oauthCodeProcessing");
          localStorage.removeItem("oauthCodeProcessingTime");
          localStorage.removeItem("oauthCodeFailed");
          localStorage.removeItem("oauthCodeFailedAt");

          if (window.opener) {
            window.close();
          } else {
            // Use full page reload instead of React Router navigate
            // This ensures App.tsx loads fresh and picks up pendingOrganization
            window.location.href = "/app/dashboard";
          }
        } else {
          console.error("Outreach auth failed:", { status, result });
          localStorage.removeItem("oauthCodeProcessing");
          localStorage.removeItem("oauthCodeProcessingTime");
          if (status === 400) {
            localStorage.setItem("oauthCodeFailed", "true");
            localStorage.setItem("oauthCodeFailedAt", Date.now().toString());
            setOutreachAuthCode("");
          }
          window.location.href = "/app/dashboard";
        }
      } catch (e) {
        if (!cancelled) {
          console.error("OutreachRedirect validate error:", e);
          localStorage.removeItem("oauthCodeProcessing");
          localStorage.removeItem("oauthCodeProcessingTime");
          window.location.href = "/app/dashboard";
        }
      } finally {
        if (!cancelled) setValidating(false);
      }
    };

    run();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, search]);

  if (validating) {
    return (
      <div className="d-flex h-100 align-items-center justify-content-center m-auto">
        <Loading variant={LoadingVariant.CIRCULAR} />
      </div>
    );
  }

  return (
    <div className="d-flex h-100 align-items-center justify-content-center m-auto">
      <div
        className="btn btn-light"
        onClick={() => window.close()}
      >
        <i className="fa-solid fa-times" /> Close
      </div>
    </div>
  );
};

export default OutreachRedirect;
